const mobileQuery = window.matchMedia('(max-width: 749px)');
const arrowSelector = '.product-media-gallery__arrows .slideshow-control';
const LOCK_DURATION = 400;
const LOCK_FLAG = 'mobileArrowLocked';
const STORED_HANDLER = 'mobileNativeOnClick';

const arrowButtons = new Set();

const syncArrowHandlers = () => {
  const buttons = document.querySelectorAll(arrowSelector);

  for (const button of buttons) {
    arrowButtons.add(button);

    if (!button.dataset[STORED_HANDLER]) {
      const nativeHandler = button.getAttribute('on:click');
      if (nativeHandler) {
        button.dataset[STORED_HANDLER] = nativeHandler;
      }
    }

    if (mobileQuery.matches) {
      if (button.hasAttribute('on:click')) {
        button.removeAttribute('on:click');
      }
    } else if (button.dataset[STORED_HANDLER] && !button.hasAttribute('on:click')) {
      button.setAttribute('on:click', button.dataset[STORED_HANDLER]);
    }
  }
};

const observer = new MutationObserver((mutations) => {
  if (
    mutations.some(
      (mutation) =>
        (mutation.type === 'childList' &&
          ([...mutation.addedNodes].some((node) => node instanceof Element && node.closest?.(arrowSelector)) ||
            [...mutation.removedNodes].some((node) => node instanceof Element && node.closest?.(arrowSelector)))) ||
        (mutation.type === 'attributes' && mutation.target instanceof Element && mutation.target.matches(arrowSelector))
    )
  ) {
    syncArrowHandlers();
  }
});

observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
mobileQuery.addEventListener('change', syncArrowHandlers);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', syncArrowHandlers, { once: true });
} else {
  queueMicrotask(syncArrowHandlers);
}

const runArrowAction = (button, event) => {
  button.dataset[LOCK_FLAG] = 'true';
  setTimeout(() => {
    delete button.dataset[LOCK_FLAG];
  }, LOCK_DURATION);

  const slideshow = button.closest('slideshow-component');
  if (!slideshow) return;

  const action = button.classList.contains('slideshow-control--next') ? 'next' : 'previous';
  const handler = /** @type {any} */ (slideshow)[action];
  if (typeof handler !== 'function') return;

  try {
    handler.call(slideshow, event);
  } catch (error) {
    console.error(error);
  }
};

const handlePointerDown = (event) => {
  if (!mobileQuery.matches) return;
  if (!(event instanceof PointerEvent) || event.pointerType === 'mouse') return;

  const target = event.target;
  if (!(target instanceof Element)) return;

  const button = target.closest(arrowSelector);
  if (!button || button.disabled) return;

  event.preventDefault();
  event.stopImmediatePropagation();

  if (button.dataset[LOCK_FLAG] === 'true') return;

  runArrowAction(button, event);
};

if (window.PointerEvent) {
  document.addEventListener('pointerdown', handlePointerDown, true);
} else {
  document.addEventListener(
    'touchstart',
    (event) => {
      if (!mobileQuery.matches) return;
      const target = event.target;
      if (!(target instanceof Element)) return;
      const button = target.closest(arrowSelector);
      if (!button || button.disabled) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      if (button.dataset[LOCK_FLAG] === 'true') return;

      runArrowAction(button, event);
    },
    { capture: true, passive: false }
  );
}
